import deep from 'deep-get-set';
import { createSelector } from 'reselect';
import { LOAD_SELECT_SUCCESS } from './organization';

// Actions
export const SIDEBAR_MENU_SHOW = 'SIDEBAR_MENU_SHOW';
export const SIDEBAR_MENU_HIDE = 'SIDEBAR_MENU_HIDE';

// Action creators
export function showSidebarMenu() {
  return {
    type: SIDEBAR_MENU_SHOW,
  };
}

export function hideSidebarMenu() {
  return {
    type: SIDEBAR_MENU_HIDE,
  };
}

// Initial state
const initialState = {
  sidebarMenuShowing: false,
};

// Reducers
export function headerReducer(state = initialState, action) {
  switch(action.type) {
    case SIDEBAR_MENU_SHOW: {
      const newState = {
        ...state,
        sidebarMenuShowing: true,
      }

      return newState;
    }

    case SIDEBAR_MENU_HIDE: {
      const newState = {
        ...state,
        sidebarMenuShowing: false,
      }

      return newState;
    }

    // Close nav drawer on route change
    // and when differen organization is selected
    case LOAD_SELECT_SUCCESS:
    case '@@router/LOCATION_CHANGE': {
      const newState = {
        ...state,
        sidebarMenuShowing: false,
      }

      return newState;
    }

    default: {
      return state;
    }
  }
}

// Selectors
export const getHeaderState = createSelector(
  state => state,
  state => state.get('header'),
);

export const getIsSidebarMenuShowing = createSelector(
  getHeaderState,
  headerState => deep(headerState, 'sidebarMenuShowing'),
);



// WEBPACK FOOTER //
// ./src/redux/modules/header.js